export enum UserTypes {
  TOGGLE_AUDIO_REQUEST = 'app/user/TOGGLE_AUDIO_REQUEST',
  TOGGLE_AUDIO_SUCCESS = 'app/user/TOGGLE_AUDIO_SUCCESS',
  TOGGLE_AUDIO_FAILURE = 'app/user/TOGGLE_AUDIO_FAILURE',
  DISABLE_TCR_BANNER_REQUEST = 'app/user/DISABLE_TCR_BANNER_REQUEST',
  DISABLE_TCR_BANNER_SUCCESS = 'app/user/DISABLE_TCR_BANNER_SUCCESS',
  DISABLE_TCR_BANNER_FAILURE = 'app/user/DISABLE_TCR_BANNER_FAILURE',
  SET_USER = 'app/user/SET_USER',
}
